import React, { useEffect, useState } from 'react';
import { ContentHeader, Table } from '@app/shared';

import { useAccountStatusDefinitions, useRefreshAccountStatusDefinitions } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { AccountStatusDefinitionForm } from './AccountStatusDefinitionForm';
import { Segment } from 'semantic-ui-react';

export function AccountStatusDefinitions() {
  const [selectedAccountStatusDefinition, setSelectedAccountStatusDefinition] = useState(undefined as any);
  const { data: accountStatusDefinitions } = useAccountStatusDefinitions();
  const refreshAccountStatusDefinitions = useRefreshAccountStatusDefinitions();
  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'name', headerName: 'Name' },
  ];

  const master = (
    <>
      <ContentHeader>
        Account Status Definitions
      </ContentHeader>
      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table items={accountStatusDefinitions} onSelectItem={setSelectedAccountStatusDefinition} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>Account Status Definition</ContentHeader>
      <AccountStatusDefinitionForm key={JSON.stringify(selectedAccountStatusDefinition)} accountStatusDefinition={selectedAccountStatusDefinition} onUpdate={refreshAccountStatusDefinitions} />
        {!selectedAccountStatusDefinition && (
            <div className="content">Please select an account status definition</div>
        )}
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
